import { getConfig } from '@constants';

export const isIOS = (): boolean => {
	const userAgent = !IS_SSR ? getConfig().userAgent : navigator?.userAgent;

	return !!userAgent.match(/ipad|iphone/i);
};
